<template>
  <div class="d-flex flex-column w-100">
    <el-card shadow="never" class="header-card">
      <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-row flex-grow-1">
          <div class="customer-logo-display">
            <el-image
              v-if="custInfo.bigImageCode"
              :src="custInfo.bigImageUrl"
              style="width: 100%;height: 100%;"
              fit="contain"
            />
            <span v-else>LOGO</span>
          </div>
          <div class="ml-2 d-flex flex-column flex-grow-1">
            <div class="flex-grow-1">
              <div class="customer-abbreviation">
                {{ custInfo.custShortName || custInfo.custName }}
              </div>
              <div class="customer-name my-1" v-if="custInfo.custShortName">
                {{ custInfo.custName }}
              </div>
            </div>
            <div class="customer-properties">
              <div
                v-if="custInfo.v_customerBizType"
                class="customer-properties-item"
              >
                <img src="./icons/balance-list.png" />
                <span>{{ custInfo.v_customerBizType }}</span>
              </div>
              <div v-if="custInfo.regionName" class="customer-properties-item">
                <img src="./icons/earth.png" />
                <span>{{ custInfo.regionName }}</span>
              </div>
              <div
                v-if="custInfo.v_customerType"
                class="customer-properties-item"
              >
                <img src="./icons/shop.png" />
                <span>{{ custInfo.v_customerType }}</span>
              </div>
              <div
                class="customer-properties-item color-tag"
                v-if="custInfo.v_custMode"
              >
                <el-tag
                  size="small"
                  :type="
                    custInfo.custMode === 'A'
                      ? 'info'
                      : custInfo.custMode === 'C'
                      ? 'success'
                      : ''
                  "
                >
                  {{ custInfo.v_custMode }}
                </el-tag>
              </div>
              <div class="customer-properties-item color-tag">
                <el-tag
                  size="mini"
                  :type="
                    !custInfo.riskLevel
                      ? 'info'
                      : custInfo.riskLevel === 'normal'
                      ? 'success'
                      : custInfo.riskLevel === 'lowRisk'
                      ? 'warning'
                      : 'danger'
                  "
                >
                  {{ custInfo.v_riskLevel || $l('form_label_riskLevel_no') }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <el-button type="primary" size="small" @click="editCustomer()">
            {{ $l('btn_editCustomer') || '编辑信息' }}
          </el-button>
          <el-dropdown
            trigger="click"
            size="small"
            class="ml-2"
            @command="command"
          >
            <i class="el-icon-more action-button"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="allow('R')"
                icon="el-icon-s-claim"
                command="risk-assessment"
              >
                {{ $l('btn_riskAssessment') || '风险核查' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="switch-tabs_wrappers">
        <div class="switch-tabs">
          <div
            v-for="item in switchTabs"
            :key="item.value"
            class="switch-tabs_items"
            :class="{ active: item.value === activeTab }"
            @click="activeTab = item.value"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <keep-alive>
        <component
          :is="activeTab"
          :ref="activeTab"
          :custCode="custCode"
          @loaded="(e) => (custInfo = e)"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import CustInfo from './components/cust-info'
import CustContactCategoryBrand from './components/cust-contact-category-brand'
import CustBusiness from './components/cust-business'
import CustFolder from './components/cust-folder'
import CustBudgetOrder from './components/cust-budget-order'
import CustChangeLog from './components/cust-change-log'
import EditLoading from '@/mixins/edit-loading'
export default {
  name: 'customerManage-myCust-detail',
  components: {
    CustInfo,
    CustContactCategoryBrand,
    CustBusiness,
    CustFolder,
    CustBudgetOrder,
    CustChangeLog,
  },
  mixins: [EditLoading],
  data() {
    return { activeTab: 'cust-info', custInfo: {} }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    custCode() {
      return this.params.custCode
    },
    switchTabs() {
      return [
        {
          label: this.$l('switchTabs_label_info') || '客户信息',
          value: 'cust-info',
        },
        {
          label:
            this.$l('switchTabs_label_contactCategoryBrand') || '品类及联系人',
          value: 'cust-contact-category-brand',
        },
        {
          label: this.$l('switchTabs_label_business') || '业务设置',
          value: 'cust-business',
        },
        {
          label: this.$l('switchTabs_label_folder') || '客户文档',
          value: 'cust-folder',
        },
        {
          label: this.$l('switchTabs_label_budgetOrder') || '预算及订单',
          value: 'cust-budget-order',
        },
        {
          label: this.$l('switchTabs_label_changeLog') || '变动日志',
          value: 'cust-change-log',
        },
      ]
    },
  },
  methods: {
    editCustomer() {
      const { custCode, custNo } = this.custInfo
      this.$router.push({
        name: 'customerManage-info-v2-detail',
        params: { custCode, pageType: 'editV2' },
        query: { custNo },
      })
    },
    command(com) {
      switch (com) {
        case 'risk-assessment':
          this.riskAssessment()
          break
      }
    },
    async riskAssessment() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_riskAssessment') || '是否生成该客户风险核查单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .customerRiskCheckAddApi({ custCode: this.custInfo.custCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_generate_ok') || '生成失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_generate_ok') || '生成成功！',
        type: 'success',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 15px;
  }

  .ql-editor,
  .el-input .el-input__inner[readonly='readonly'] {
    background-color: #f9f9f9;
    border: none;
  }

  .header-card {
    margin-bottom: 10px;
    .el-card__body {
      padding-bottom: 0;
    }
  }
}
.customer-logo-display {
  --size: 75px;
  width: var(--size);
  height: var(--size);
  min-width: var(--size);
  background-color: #f4f6f9;
  font-size: 14px;
  color: #101010;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.customer-abbreviation {
  font-size: 16px;
  color: #101010;
  padding-right: 5px;
}
.customer-name {
  font-size: 14px;
  color: #8e8e8e;
}

.customer-properties {
  display: flex;
  align-items: center;
  .customer-properties-item {
    font-size: 14px;
    color: #8e8e8e;
    display: flex;
    align-items: center;
    margin-right: 10px;
    img {
      width: 18px;
      height: 18px;
      margin-right: 2px;
    }
  }
  .customer-properties-item.color-tag {
    padding-left: 5px;
  }
  .customer-properties-item.color-tag:last-child {
    padding-left: 0;
  }
}

.action-button {
  width: 32px !important;
  height: 32px !important;
  font-size: 18px !important;
  text-align: center;
  line-height: 32px !important;
  cursor: pointer;
  border-radius: 4px;
  background-color: #f8f8f8;
}
.action-button:hover {
  color: #007bff !important;
  background-color: #e7f1fe !important;
}

.switch-tabs_wrappers {
  margin-top: 6px;
  .switch-tabs {
    display: flex;
    .switch-tabs_items {
      padding: 18px 2px 16px;
      color: #8e8e8e;
      font-size: 14px;
      margin-right: 26px;
      cursor: pointer;
      min-width: max-content;
      border-bottom: 3px solid transparent;
    }
    .switch-tabs_items:hover,
    .switch-tabs_items.active {
      color: #007bff;
      border-color: #1989fa;
    }
    .switch-tabs_items.disabled {
      cursor: no-drop;
    }
    .switch-tabs_items.disabled:hover {
      color: #8cc5ff;
      border-color: #7ab8f6;
    }
    .switch-tabs_items:last-child {
      margin-right: 0;
    }
  }
}
</style>
